import React, { Component } from 'react'
import { TextField, InputAdornment } from '@material-ui/core'
// import { FaKeybase } from 'react-icons/fa'

export class Social extends Component {
  render() {
    return (
      <div>
        <TextField
          style={{
            margin: '6px'
          }}
          label="Twitter"
          name="twitter"
          id="twitter"
          value={(this.props.twitter && this.props.twitter) || ''}
          placeholder="@username"
          margin="dense"
          className="text-field-style"
          variant="outlined"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <div className="twitter">
                  <i className="fa fa-twitter"></i>
                </div>
              </InputAdornment>
            )
          }}
          autoComplete="false"
          onChange={this.props.onChange}
        />
        <TextField
          style={{
            margin: '6px'
          }}
          label="Telegram"
          name="telegram"
          id="telegram"
          value={(this.props.telegram && this.props.telegram) || ''}
          placeholder="username"
          margin="dense"
          className="text-field-style"
          variant="outlined"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <div className="telegram">
                  <i className="fa fa-telegram"></i>
                </div>
              </InputAdornment>
            )
          }}
          autoComplete="false"
          onChange={this.props.onChange}
        />
        <TextField
          style={{
            margin: '6px'
          }}
          label="Whatsapp"
          name="whatsapp"
          id="whatsapp"
          value={(this.props.whatsapp && this.props.whatsapp) || ''}
          placeholder="9665xxxxxxxx"
          margin="dense"
          className="text-field-style"
          variant="outlined"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <div className="whatsapp">
                  <i className="fa fa-whatsapp"></i>
                </div>
              </InputAdornment>
            )
          }}
          autoComplete="false"
          onChange={this.props.onChange}
        />
        <TextField
          style={{
            margin: '6px'
          }}
          label="Facebook"
          name="facebook"
          id="facebook"
          margin="dense"
          value={(this.props.facebook && this.props.facebook) || ''}
          placeholder="https://www.facebook.com/username/"
          className="text-field-style"
          variant="outlined"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <div style={{ padding: '3px' }} className="facebook">
                  <i className="fa fa-facebook"></i>
                </div>
              </InputAdornment>
            )
          }}
          autoComplete="false"
          onChange={this.props.onChange}
        />
        <TextField
          style={{
            margin: '6px'
          }}
          label="Instagram"
          name="instagram"
          id="insta"
          value={(this.props.instagram && this.props.instagram) || ''}
          placeholder="username"
          margin="dense"
          className="text-field-style"
          variant="outlined"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <div className="insta">
                  <i className="fa fa-instagram"></i>
                </div>
              </InputAdornment>
            )
          }}
          autoComplete="false"
          onChange={this.props.onChange}
        />
        <TextField
          style={{
            margin: '6px'
          }}
          label="Snapchat"
          name="snapchat"
          id="snapchat"
          value={(this.props.snapchat && this.props.snapchat) || ''}
          placeholder="username"
          margin="dense"
          className="text-field-style"
          variant="outlined"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <div className="snapchat">
                  <i className="fa fa-snapchat"></i>
                </div>
              </InputAdornment>
            )
          }}
          autoComplete="false"
          onChange={this.props.onChange}
        />
        <TextField
          style={{
            margin: '6px'
          }}
          label="Github"
          name="github"
          id="github"
          value={(this.props.github && this.props.github) || ''}
          placeholder="username"
          margin="dense"
          className="text-field-style"
          variant="outlined"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <div className="text-color">
                  <i className="fa fa-github"></i>
                </div>
              </InputAdornment>
            )
          }}
          autoComplete="false"
          onChange={this.props.onChange}
        />
        <TextField
          style={{
            margin: '6px'
          }}
          label="Keybase"
          name="keybase"
          id="keybase"
          value={(this.props.keybase && this.props.keybase) || ''}
          placeholder="username"
          margin="dense"
          className="text-field-style"
          variant="outlined"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <div className="text-color"></div>
              </InputAdornment>
            )
          }}
          autoComplete="false"
          onChange={this.props.onChange}
        />
      </div>
    )
  }
}
export default Social
